/* @flow */

import React, { useContext } from "react";
import { NotificationBar } from "@crossroads/ui-components";
import { useNotification } from "helpers/use-notification";
import { useTranslate } from "@awardit/react-use-translate";
import { StoreInfoContext } from "entrypoint/shared";
import cn from "classnames";

import styles from "./styles.scss";

const Notifications = () => {
  const t = useTranslate();
  const { info } = useContext(StoreInfoContext);
  const {
    showAddressNotificationBar,
    showNotificationBar,
    setShowAddressNotificationBar,
    setShowNotificationBar,
    multipleNotifications,
  } = useNotification();

  return (
    <>
      {showAddressNotificationBar &&
        <NotificationBar
          text={t("MISSING_ADDRESS_TEXT")}
          closeBtnTitle={t("CONFIRM_DIALOG.CLOSE")}
          onClose={() => setShowAddressNotificationBar(false)}
        />
      }
      {showNotificationBar &&
        <NotificationBar
          wrapperClassName={cn({ [styles.bottom]: multipleNotifications })}
          text={info.popUp?.body}
          closeBtnTitle={t("CONFIRM_DIALOG.CLOSE")}
          onClose={() => setShowNotificationBar(false)}
        />
      }
    </>
  );
};

export default Notifications;
